// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { ToastEventModel, ToastModel } from '../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AppToastService {
  private _toastClicked$: BehaviorSubject<ToastEventModel | null> = new BehaviorSubject<ToastEventModel | null>(null);
  get toastClicked$(): Observable<ToastEventModel | null> {
    return this._toastClicked$;
  }

  private _toasts: ToastModel[];

  private _toasts$: BehaviorSubject<ToastModel[]>;
  get toasts$(): Observable<ToastModel[]> {
    return this._toasts$;
  }

  constructor() {
    this._toasts = new Array<ToastModel>();
    this._toasts$ = new BehaviorSubject<ToastModel[]>(this._toasts);
   }

   show(toast: ToastModel) {
    this._toasts = [ ...this._toasts, toast ];
    this._toasts$.next(this._toasts);
  }

  remove(toast: ToastModel) {
    this._toasts = this._toasts.filter(t => t !== toast);
    this._toasts$.next(this._toasts);
  }

  clickNotify(toastEvent: ToastEventModel) {
    if (toastEvent) {
      this._toastClicked$.next(toastEvent);
    }
  }
}
